module.exports = __webpack_public_path__ + "img/青皮.3fba2d3a.jpg";